import { formatDecimal } from "./formatNumber";
import { formatearMonedaCliente } from "./formatearMonedaCliente";

/**
 * Separa un monto en { monto, sigla } para el portal cliente V2. Para CLP
 * prepende `$` al monto; para el resto la sigla queda como token aparte.
 *
 * Redondea a 2 decimales para evitar artefactos de punto flotante en las sumas
 * de totales/subtotales (ej. 0.4 + 0.2 = 0.6000000000000001) y unificar la
 * precision con formatValorPlan.
 */
export function splitMontoMoneda(valor, moneda) {
  const sigla = formatearMonedaCliente(moneda);
  const num = Math.round((Number(valor) || 0) * 100) / 100;
  const monto = formatDecimal(num);
  if (sigla === "CLP") return { monto: `$${monto}`, sigla: "CLP" };
  return { monto, sigla };
}
